<template>
  <v-container app>
    <v-row class="fill-height">
      <v-col>
        <lander></lander>
      </v-col>
    </v-row>
    <v-row class="pt-6 pb-12" justify="center" align="center">
      <v-col
          align-self="center"
          cols="auto"
          justify-center
      >
          <v-btn icon large v-scroll-to="'#teaching'" :retain-focus-on-click="false">
              <v-icon
                  large
                  color="light-blue darken-4"
                  dark
              >
                  mdi-chevron-down
              </v-icon>
          </v-btn>
      </v-col>
    </v-row>
    <v-row class="fill-height"> 
      <v-col>
        <teaching id="teaching"></teaching>
      </v-col>
    </v-row>
    <v-row class="pt-6 pb-12" justify="center" align="center">
      <v-col
          align-self="center"
          cols="auto"
          justify-center
      >
          <v-btn icon large v-scroll-to="'#research'" :retain-focus-on-click="false">
              <v-icon
                  large
                  color="light-blue darken-4"
                  dark
              >
                  mdi-chevron-down
              </v-icon>
          </v-btn>
      </v-col>
    </v-row>
    <v-row class="fill-height"> 
      <v-col>
        <research id="research"></research>
      </v-col>
    </v-row>
    <v-row class="pt-2 pb-12" justify="center" align="center">
      <v-col
          align-self="center"
          cols="auto"
          justify-center
      >
          <v-btn icon large v-scroll-to="'#resume'" :retain-focus-on-click="false">
              <v-icon
                  large
                  color="light-blue darken-4"
                  dark
              >
                  mdi-chevron-down
              </v-icon>
          </v-btn>
      </v-col>
    </v-row>
    <v-row class="fill-height"> 
      <v-col>
        <resume id="resume"></resume>
      </v-col>
    </v-row>
    <v-row class="pt-6 pb-12" justify="center" align="center">
      <v-col
          align-self="center"
          cols="auto"
          justify-center
      >
          <v-btn icon large v-scroll-to="'#contact'" :retain-focus-on-click="false">
              <v-icon
                  large
                  color="light-blue darken-4"
                  dark
              >
                  mdi-chevron-down
              </v-icon>
          </v-btn>
      </v-col>
    </v-row>
    <v-row class="fill-height"> 
      <v-col>
        <contact id="contact"></contact>
      </v-col>
    </v-row>
    <v-btn 
      class="mr-4 mb-4 hidden-sm-and-down" 
      v-model="fab" 
      fixed 
      right 
      bottom
      icon extra-large 
      v-scroll-to="'#lander'"
      :retain-focus-on-click="false">
      <v-icon
          large
          color="light-blue darken-4"
      >
          mdi-home-outline
      </v-icon>
    </v-btn>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Lander from "@/components/Lander";
import Teaching from "@/components/Teaching";
import Research from "@/components/Research";
import Resume from "@/components/Resume";
import Contact from "@/components/Contact";

export default {
  name: "Home",
  components: {
    Lander,
    Teaching,
    Research,
    Resume,
    Contact
  }
};
</script>

<style scoped>
.v-row {
  padding-top: 2%;
}

</style>
